export enum BuilderTourEnum {
  OUTLINE_POPUP,
  START,
  INTRO,
  PAGE_BUILDER,
  CUSTOMIZER,
  GENERATION,
  END
}

export enum NewBuilderTourEnum {
  ADD_SECTION_BTN,
  ADD_SECTION_LIST,
  EDIT_SECTION,
  ADD_PAGE,
}

export enum BuilderStepsEnum {
  CHOOSE_BUSINESS_TYPE,
  FILL_COMPANY_INFO,
  PRODUCT_TYPE,
  SHOW_CANVAS,
  SHOW_DESIGN,
  SHOW_FINALIZE,
  SHOW_HERO,
}

export enum QuestionTourEnum {
  START,
  CUSTOMIZE,
  STYLE,
  END
}

export enum CompanyType {
  ECOMMERCE = 'ecommerce',
  DEFAULT = 'default'
}
